module.exports = __webpack_public_path__ + "media/images/promo/change-659a4b24302e57cbc2a541457ea42dc31f2191345ff9971414dcda39ae0a0ce3.png";